/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { IInspectorControlEnumProps } from "./InspectorControlEnum.common";
import { InspectorControlEnum_Buttons } from "./InspectorControlEnum_Buttons";
import { InspectorControlEnum_Select } from "./InspectorControlEnum_Select";

export const InspectorControlEnum: React.FC<IInspectorControlEnumProps> = ({ model }) => {
	switch (model.schema.opts.editorOptions?.controlType) {
		case "buttons":
			return <InspectorControlEnum_Buttons model={model} />;
		default:
			return <InspectorControlEnum_Select model={model} />;
	}
};
